/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
* Licensed Under MIT (http://opensource.org/licenses/MIT)
*
* React File Base64 - Version@1.0.0
*
*/

import React from 'react';
import { ErrorMessage } from 'formik';
import { Error } from './styles';

const FileBase64 = ({
  name,
  error,
  multiple,
  onDone,
  ...props
}) => {

  const handleChange = function (e) {

    // get the files
    let files = e.target.files;

    // Process each file
    var allFiles = [];
    for (var i = 0; i < files.length; i++) {

      let file = files[i];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {

        // Make a fileInfo Object
        let fileInfo = {
          name: file.name,
          type: file.type,
          size: Math.round(file.size / 1000) + ' kB',
          base64: reader.result,
          file: file,
        };

        // Push it to the state
        allFiles.push(fileInfo);

        // If all files have been proceed
        if(allFiles.length == files.length){
          // Apply Callback function
          if (onDone) {
            if(multiple) onDone(allFiles);
            else onDone(allFiles[0]);
          }
        }

      } // reader.onload

    } // for

  }

  return (
    <>
      <div style={{ display: 'flex', width:'100%' }}>
        <input
          type="file"
          name={name}
          onChange={ handleChange.bind(this) }
          multiple={ multiple } 
          {...props}
        />
      </div>
      {/* <Error>
        <ErrorMessage name={name} />
        {error}
      </Error> */}
    </>
  );
}

export default FileBase64;